import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { PropertyDto } from '@workspace/data-types';

@Component({
  selector: 'etxe-property-summary',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './property-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertySummaryComponent {
  property = input.required<PropertyDto>();
  debug = output<void>();

  totalPieces = computed(() => {
    const chars = this.property().characteristics;
    const interior = chars.interior;
    if (!interior) return 0;

    const roomsCount = interior.rooms?.length ?? 0;
    const bedroomsCount = interior.bedroom?.length ?? 0;
    return roomsCount + bedroomsCount;
  });
}
